import React from 'react'
import { Box, Divider, Typography } from '@mui/material'
import { Form } from './Form'

export const Contact = () => {
  return (
    <Box sx={{ mt: 8 }}>
        <Typography id="contact" variant="h5" fontWeight={600} sx={{mb:2}}>
            📱Contact
        </Typography>
        <Divider sx={{mb:5}} />
        <Typography color="text.secondary">
            <Box sx={{
              display: "inline",
              color: "black"
            }}>
              🤙
            </Box>
             Want to connect or hire me? Then shoot me an email via
            <Box sx={{
              color: "text.primary",
              display: "inline",
              fontWeight: "bold",
              fontSize: 14,
              mx: 0.5
            }}>
              davidsibanda776@gmail.com
            </Box>
            <Form />
        </Typography>
    </Box>
  )
}
